var React = require('react');

function StepCircle0260px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm6.804-18v-1.44h-11.52v-.072l1.656-1.728c5.868-5.796 9.216-9.504 9.216-14.112 0-2.772-1.656-6.444-6.516-6.444-2.412 0-4.464.972-5.976 2.34l.684 1.188c1.008-.864 2.736-2.016 4.968-2.016 3.96 0 5.076 2.628 5.076 5.292 0 4.032-2.844 7.344-9.36 13.716l-2.16 2.232V42h13.932z"}));
}

StepCircle0260px.displayName = "StepCircle0260px";

StepCircle0260px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0260px;

StepCircle0260px.default = StepCircle0260px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-02-60px.svg
// module id = 1207
// module chunks = 0